import { useRef, useState } from 'react';

import { ArrowMoveDownLeftIcon, CancelCircleIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { useClickOutside } from 'hooks/click-outside';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Input } from 'components/FormComponents';

import styles from './FloatingInput.module.scss';

export const FloatingInput = ({ className, onClick = () => {}, onClose = () => {}, ...props }) => {
  const [inputValue, setInputValue] = useState('');
  const floatingInputRef = useRef(null);
  useClickOutside(floatingInputRef, () => onClose());

  const handleClick = value => {
    onClick(value);
    setInputValue('');
  };

  return (
    <div
      ref={floatingInputRef}
      className={cn(
        styles.root,
        className,
        'u-absolute u-z-index-10 u-border u-border-radius--medium u-drop-shadow--large u-padding--small surface-white d-flex align-items-center u-gap',
      )}>
      <Input
        {...props}
        onBlur={v => setInputValue(v)}
        onActionClick={handleClick}
        actionIcon={ArrowMoveDownLeftIcon}
        newIconLibrary
        actionIconTip="Apply link"
      />
      <div className={cn(styles.closeButton, 'u-pointer d-flex align-items-center u-gap')}>
        <OverlayTrigger
          trigger={['hover', 'focus', 'click']}
          placement="top"
          overlay={<Tooltip>Close</Tooltip>}>
          <HugeiconsIcon icon={CancelCircleIcon} size={20} color="#5c4d78" onClick={onClose} />
        </OverlayTrigger>
      </div>
    </div>
  );
};
